import type { Edge, Node } from "./FlujoBaseSVG";

interface PathProps {
	readonly edges: Edge[];
	readonly nodes: Node[];
	readonly width: number;
	readonly height: number;
}
export function Paths(props: PathProps) {
	return (
		<svg
			style={{ width: props.width, height: props.height }}
			viewBox={`0 0 ${props.width} ${props.height}`}
		>
			{props.edges.map((edge) => (
				<path
					key={edge.id}
					d={pathForEdge(edge, props.nodes)}
					stroke="#000"
					fill="none"
					strokeWidth={1}
				/>
			))}
		</svg>
	);
}

function pathForEdge(edge: Edge, nodes: Node[]) {
	const source = nodes.find((n) => n.id === edge.source);
	const target = nodes.find((n) => n.id === edge.target);

	if (!source || !target) return "";

	const sx = source.position.x + source.size.width;
	const sy = source.position.y + source.size.height / 2;
	const tx = target.position.x;
	const ty = target.position.y + target.size.height / 2;

	// how "wide" the curve is
	const offset = Math.min((tx - sx) / 2, 150);

	return `
		M ${sx - 10},${sy}
		L ${sx},${sy}
		C ${sx + offset},${sy} ${tx - offset},${ty} ${tx},${ty}
		L ${tx + 10},${ty}
	`;
}